import { VERA, SOCIALS } from "@/lib/constants";
import { ArrowLeft } from "lucide-react";

export default function Privacy() {
  return (
    <div className="min-h-screen bg-[#FBF7F0] py-10 px-5">
      <div className="max-w-3xl mx-auto">
        <a href="/" className="inline-flex items-center gap-1 text-sm text-[#5B6B61] hover:text-[#2C3E35] mb-6">
          <ArrowLeft size={16} /> Terug
        </a>
        <div className="bg-white rounded-3xl p-6 sm:p-10 shadow-[0_8px_30px_rgba(44,62,53,0.04)] border border-[#E5E7E1]">
          <h1 className="text-3xl sm:text-4xl text-[#2C3E35] mb-2">Privacyverklaring</h1>
          <p className="text-sm text-[#8FA38C] mb-8">
            Conform de Belgische en Europese GDPR-wetgeving (AVG)
          </p>

          <div className="space-y-6 text-[#5B6B61] leading-relaxed text-sm sm:text-base">
            <section>
              <h2 className="text-xl text-[#2C3E35] mb-2">1. Verwerkingsverantwoordelijke</h2>
              <p>
                {VERA.brand} — {VERA.name}, {VERA.role}, {VERA.location}. Website:{" "}
                <a href={SOCIALS.website} className="text-[#6B8E74] underline" target="_blank" rel="noopener noreferrer">
                  gezondmetvera.be
                </a>
                .
              </p>
            </section>

            <section>
              <h2 className="text-xl text-[#2C3E35] mb-2">2. Welke gegevens verzamelen wij?</h2>
              <p>
                Voornaam, leeftijd, geslacht, gemeente, e-mailadres, telefoonnummer en jouw
                antwoorden op de welzijnscheck. Deze gegevens worden vrijwillig door jou verstrekt.
              </p>
            </section>

            <section>
              <h2 className="text-xl text-[#2C3E35] mb-2">3. Waarvoor gebruiken wij je gegevens?</h2>
              <p>
                Je gegevens worden verwerkt in het kader van dit marktonderzoek naar welzijn en
                gezondheid, om jou jouw persoonlijke welzijnsscore te bezorgen en om je te
                contacteren over jouw resultaten en de eventueel aangevraagde gratis
                welzijnsevaluatie inclusief bodyscan. De rechtsgrond is jouw uitdrukkelijke
                toestemming (art. 6.1.a AVG).
              </p>
            </section>

            <section>
              <h2 className="text-xl text-[#2C3E35] mb-2">4. Bewaartermijn</h2>
              <p>
                Wij bewaren je gegevens niet langer dan noodzakelijk voor bovenstaande doeleinden en
                verwijderen ze op jouw verzoek.
              </p>
            </section>

            <section>
              <h2 className="text-xl text-[#2C3E35] mb-2">5. Jouw rechten</h2>
              <p>
                Je hebt het recht op inzage, correctie, verwijdering, beperking en overdraagbaarheid
                van je gegevens, en je kan je toestemming op elk moment intrekken. Neem hiervoor
                contact op via de gegevens van Gezond met Vera. Je hebt eveneens het recht om een
                klacht in te dienen bij de Gegevensbeschermingsautoriteit (www.gegevensbeschermingsautoriteit.be).
              </p>
            </section>

            <section>
              <h2 className="text-xl text-[#2C3E35] mb-2">6. Delen met derden</h2>
              <p>
                Je gegevens worden niet verkocht of gedeeld met derden voor commerciële doeleinden en
                worden uitsluitend gebruikt binnen dit onderzoek.
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}
